import Primarytheme from '../utility/theme';
import { Stack } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import HelpIcon from '@mui/icons-material/Help';
import { useEffect, useState } from 'react';


export default function CustomCheckbox({ conf, setConf, groupKey, i }) {

    const [checked , setChecked] = useState(conf.integrationsOptions[groupKey][i].value)

    const handleChangeCheckOption = (newVal) => {
        setChecked(newVal)
        let newConf = {...conf}
        newConf.integrationsOptions[groupKey][i].value = newVal
        setConf(newConf)
        //console.log(conf)
    }

    return (
        <Stack direction='row' alignItems='center' sx={{ marginBottom: '2em' }}>
            <FormControlLabel
                label={conf.integrationsOptions[groupKey][i].nome}
                control={<Checkbox
                    checked={checked}
                    onChange={(e) => handleChangeCheckOption(e.target.checked)}
                />}
            />
            <Tooltip title={
                <Typography variant='caption' >
                    {conf.integrationsOptions[groupKey][i].descrizione}
                </Typography>}>
                <HelpIcon sx={{ fontSize: '1em', ml: '0.5em', color: Primarytheme.palette.neutral.main }} />
            </Tooltip>
        </Stack>
    )
}